module.exports = __webpack_public_path__ + "static/media/ecity.6b274fa1.png";